import { useCallback } from 'react';

const useScrollTo = (targetRef, scrollOffset = 0) => {
    const scrollTo = useCallback(() => {
        if (!targetRef.current) {
            return;
        }

        const element = targetRef.current;
        const top = element.getBoundingClientRect().top + window.scrollY + scrollOffset;

        window.scrollTo({ top, behavior: 'smooth' });
    }, [targetRef, scrollOffset]);

    return scrollTo;
};

export default useScrollTo;
